//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import CbDialog from '../dialog';
import { props } from './props';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('CbDialog', _vm._g(_vm._b({
    attrs: {
      "visible": true
    },
    on: {
      "icon-close": _vm.handleClose
    }
  }, 'CbDialog', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns = [];
export default defineComponent({
  render,
  name: 'CbModal',
  props,
  inheritAttrs: false,
  components: {
    CbDialog
  },
  methods: {
    handleClose() {
      this.$emit('close');
    }
  }
});